import { get } from '../../Common/utils';

import { dropDownDefault } from './constants';

const normalizeAggregators = (aggregators = []) =>
  dropDownDefault.concat(
    aggregators.map(aggregator => ({
      label: get(aggregator, 'aggregatorID', ''),
      value: get(aggregator, 'aggregatorID', ''),
    })),
  );

const normalizePayers = (payers = []) =>
  payers.map(payer => ({
    payerID: get(payer, 'payerID', ''),
    payerName: get(payer, 'payerName', ''),
  }));

export { normalizeAggregators, normalizePayers };
